import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import LanguageTranslation from "./LanguageTranslation";
import { Container } from "./styled";
import SuccssfullMessage from "./SuccessfullMessage";
import lockImage from "../../template/images/Lock.png";
import loader from "../../assets/images/loader.gif";

import "react-toastify/dist/ReactToastify.css";
import "./flags.css";
import FormTypes from "./FormTypes";
import { CorporateForm } from "../coprateForm/CorporateForm";

const FormContainer = () => {
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("Corporate");
  const [submittedData, setSubmittedData] = useState(null);

  const { i18n } = useTranslation();

  return (
    <div
      className={`d-flex align-items-center justity-content-center ${
        formType === "Individual"
          ? "IndividuallayoutContainer"
          : "CopratelayoutContainer"
      }`}
    >
      {loading ? (
        <div id="global-loader1">
          <img src={loader} className="loader-img" alt="Loading...." />
        </div>
      ) : (
        <div className="container rounded corporateContainer p-0 w-100">
          <Row className="top_security w-100">
            <p
              style={{ marginBottom: "0px", fontSize: "13px" }}
              className={`top_sec_p d-flex align-items-center justify-content-center ${
                i18n.language === "de" || "ir" ? "flex-row-reverse" : ""
              }`}
            >
              <img
                src={lockImage}
                style={{
                  marginTop: "-3px",
                  width: "18px",
                  marginRight: i18n.language !== "de" || "ir" ? "15px" : 0,
                  marginLeft: i18n.language === "de" || "ir" ? "15px" : 0,
                }}
                alt="Lock Icon"
              />
              This is a secure online registration
            </p>
          </Row>
          <Row style={{ alignItems: "center", margin: "5px" }}>
            <Col
              md={6}
              className="d-flex justify-content-center justify-content-md-start mb-3 mb-md-0"
            >
              <img
                src="https://www.godocm.com/wp-content/uploads/2025/05/cropped-GoDo-Logo-7-1.png"
                alt="logo"
                className="mt-2"
                style={{ width: "70px", height: "70px" }}
              ></img>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center justify-content-md-end gap-3"
            >
              <FormTypes className="logoCss" setFormType={setFormType} type='Corporate' />
              {formType === "Individual" && (
                <LanguageTranslation className="logoCss" />
              )}
            </Col>
          </Row>
          <Row className="mt-3 mt-lg-2 mx-0 w-100">
            <h1 className="text-center secondary">Application Form</h1>
            <p className="text-center primary fw-bold">You're Just a Step Away from Achieving Your Financial Goals... Dive In Now!</p>
          </Row>
          {!loading && !submittedData ? (
            <Container>
              <CorporateForm
                setLoadingMain={setLoading}
                loadingMain={loading}
                setSubmittedData={setSubmittedData}
              />
            </Container>
          ) : (
            <SuccssfullMessage
              loading={loading}
              setLoading={setLoading}
              submittedData={submittedData}
            />
          )}
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default FormContainer;
